import React from "react";
import DeleteCustomerContainer from "../../containers/customers/DeleteCustomerContainer";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Button, Grid, Box, Typography } from "@material-ui/core";

const DeleteCustomer = ({ handleClose, open, profile }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("delete_customer.title")}
    >
      {profile ? (
        <DeleteCustomerContainer customer={profile} onClose={handleClose}>
          {({ onSubmit, customer }) => (
            <Box
              mt={1}
              boxShadow={{ xs: 0, sm: 2 }}
              display="flex"
              flexDirection="column"
              p={2}
            >
              <Box mt={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography color="textPrimary">
                      {t("delete_customer.text")}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => onSubmit(customer)}
                    >
                      {t("delete_customer.button_text")}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          )}
        </DeleteCustomerContainer>
      ) : null}
    </Modal>
  );
};

export default DeleteCustomer;
